<script lang="ts">
	import { TableHeadCell } from "flowbite-svelte";
	import { twMerge } from "tailwind-merge";
	import { Order, type PaginationArguments } from "#gen/common/v1/pagination_pb.js";
	import Icon from "#lib/components/Icon.svelte";

	export let sortKey: string;
	export let pagination: PaginationArguments | undefined;

	function sort() {
		if (!pagination) {
			return;
		}
		if (sortKey === pagination.orderBy) {
			pagination = { ...pagination, order: pagination?.order == Order.ASC ? Order.DESC : Order.ASC, after: undefined, before: undefined };
		} else {
			pagination = { ...pagination, orderBy: sortKey, order: Order.ASC, after: undefined, before: undefined };
		}
	}

	$: tableDataAttributes = {
		"data-action-name": "table-head-sort",
		"data-sort-key": sortKey,
		"data-order": pagination?.order === Order.ASC ? "DESC" : "ASC", // set data-order only if the column is sorted, and swap the order for analytics attributes because the click action changes the order
	};
</script>

<TableHeadCell {...tableDataAttributes} {...$$restProps} class={twMerge($$restProps.class, "cursor-pointer")} on:click={sort}>
	<div class="flex items-center">
		<slot />
		{#if sortKey == pagination?.orderBy}
			<Icon class="ml-2 inline-block flex-none" width="12" height="12" name={pagination?.order == Order.ASC ? "chevron-up" : "chevron-down"} />
		{:else}
			<Icon class="ml-2 inline-block flex-none" width="14" height="14" name="chevron-up-down" />
		{/if}
	</div>
</TableHeadCell>
